import { chartColors } from "../enums/ChartColors";

function ComputedColors(variable?: string): string[] | string {
    const rootStyles = getComputedStyle(document.documentElement);

    if (variable) {
        return rootStyles.getPropertyValue(variable).trim();
    }

    return chartColors.map(colorVar => rootStyles.getPropertyValue(colorVar.replace("var(", "").replace(")", "")).trim());
};

export default ComputedColors;